module.exports = __webpack_public_path__ + "files/685b52d269ce3ffd763cd50055d2269f.png";